import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5cf56921"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "faq",
  class: "com-div clearfix loginContainer sUp"
};
const _hoisted_2 = {
  class: "login",
  id: "register_input"
};
const _hoisted_3 = {
  class: "login-top"
};
const _hoisted_4 = {
  class: "login-form-p"
};
const _hoisted_5 = {
  class: "lg-div sUDivCon username"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sUError username"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createElementVNode("span")], -1));

const _hoisted_8 = {
  class: "login-form-p"
};
const _hoisted_9 = {
  class: "lg-div sUDivCon email"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sUError email"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createElementVNode("span")], -1));

const _hoisted_12 = {
  class: "login-form-p"
};
const _hoisted_13 = {
  class: "lg-div sUDivCon password"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sUError password"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createElementVNode("span")], -1));

const _hoisted_16 = {
  class: "login-form-p"
};
const _hoisted_17 = {
  class: "lg-div sUDivCon confirmPassword"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sUError confirmPassword"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createElementVNode("span")], -1));

const _hoisted_20 = {
  class: "login-form-p"
};
const _hoisted_21 = {
  class: "lg-div sUDivCon captcha"
};
const _hoisted_22 = ["src"];

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sUError captcha"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createElementVNode("span")], -1));

const _hoisted_24 = {
  class: "sUCheck sUDivCon"
};
const _hoisted_25 = {
  class: "checkbox"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "agreement"
}, null, -1));

const _hoisted_27 = {
  class: "agreement"
};

const _hoisted_28 = /*#__PURE__*/_createTextVNode();

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sUError commonInfo"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}), /*#__PURE__*/_createTextVNode(), /*#__PURE__*/_createElementVNode("span", {
  id: "error_info"
})], -1));

const _hoisted_30 = {
  class: "singnIn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("Sign up")), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('Username')), 1), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.username = $event),
    type: "text",
    class: "lg-input",
    id: "username"
  }, null, 512), [[_vModelText, _ctx.username]]), _hoisted_6]), _hoisted_7, _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("Email")), 1), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.email = $event),
    type: "text",
    class: "lg-input",
    id: "email"
  }, null, 512), [[_vModelText, _ctx.email]]), _hoisted_10]), _hoisted_11, _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("Password")), 1), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.password = $event),
    type: "password",
    class: "lg-input",
    id: "password"
  }, null, 512), [[_vModelText, _ctx.password]]), _hoisted_14]), _hoisted_15, _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("Password Confirmation")), 1), _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.confirmPassword = $event),
    type: "password",
    class: "lg-input",
    id: "confirmPassword"
  }, null, 512), [[_vModelText, _ctx.confirmPassword]]), _hoisted_18]), _hoisted_19, _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("Verification")), 1), _createElementVNode("div", _hoisted_21, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.code = $event),
    type: "text",
    class: "lg-input ver",
    id: "captcha"
  }, null, 512), [[_vModelText, _ctx.code]]), _createElementVNode("div", {
    class: "vereRight",
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    (...args) => _ctx.getCaptchaFn && _ctx.getCaptchaFn(...args))
  }, [_createElementVNode("img", {
    id: "img110",
    style: {
      "cursor": "pointer"
    },
    src: _ctx.codeImg
  }, null, 8, _hoisted_22)])]), _hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.agreement = $event),
    type: "checkbox",
    id: "agreement",
    name: "agreement"
  }, null, 512), [[_vModelCheckbox, _ctx.agreement]]), _hoisted_26]), _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("I have read the agreement")), 1), _hoisted_28, _createElementVNode("a", {
    class: "agreement agA",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.routerJump('agreement'))
  }, " 《" + _toDisplayString(_ctx.$t("GOBY Community User Agreement")) + "》 ", 1)]), _hoisted_29, _createElementVNode("button", {
    onClick: _cache[8] || (_cache[8] = //@ts-ignore
    (...args) => _ctx.signUpFn && _ctx.signUpFn(...args)),
    class: "login-btn"
  }, _toDisplayString(_ctx.$t('Sign up')), 1), _createElementVNode("span", _hoisted_30, [_createElementVNode("a", {
    onClick: _cache[9] || (_cache[9] = $event => _ctx.toPage('/signIn')),
    class: "singnIn"
  }, _toDisplayString(_ctx.$t('Sign in')), 1)])])]);
}